export default function ImageBox() {
  return <img src="/images/image-qr-code.png" alt={"image-qr-code"} />;
}
